<div class="error-container">
  <div class="error-content">
    <!-- Error Icon -->
    <div class="error-icon">
      <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="#ef4444" stroke-width="2"/>
        <line x1="15" y1="9" x2="9" y2="15" stroke="#ef4444" stroke-width="2"/>
        <line x1="9" y1="9" x2="15" y2="15" stroke="#ef4444" stroke-width="2"/>
      </svg>
    </div>

    <!-- Error Message -->
    <div class="error-message">
      <h1 class="error-title">Missing Company ID</h1>
      <p class="error-description">
        This application requires a valid company identifier to function properly. 
        The <code>cid</code> (company ID) parameter was not found in the URL or is invalid.
      </p>
    </div>

    <!-- Error Details -->
    <div class="error-details">
      <h3>How to fix this:</h3>
      <ol>
        <li>Contact your system administrator to get the correct URL with the encoded company ID</li>
        <li>Make sure your URL includes the <code>cid</code> parameter with a valid encoded company ID:
          <div class="example-url">
            <code>{{ getExampleUrl() }}</code>
          </div>
        </li>
        <li>The company ID is encoded for security - you cannot create this URL manually</li>
        <li>If you were redirected here, please go back to your original source</li>
      </ol>
    </div>

    <!-- Action Buttons -->
    <div class="error-actions">
      <button class="btn btn-primary" (click)="reloadPage()">
        <span class="btn-icon">🔄</span>
        Reload Page
      </button>
      <button class="btn btn-secondary" (click)="goToHomepage()">
        <span class="btn-icon">🏠</span>
        Go to Homepage
      </button>
    </div>

    <!-- Support Information -->
    <div class="support-info">
      <p class="support-text">
        Need help? Contact your system administrator or check your integration documentation.
      </p>
    </div>
  </div>
</div> 